/**
* Enums.ts
* @author Abhilash Panwar (abpanwar)
* @copyright Microsoft 2020
* File containing enums for EI.
*/
export var ActionType = {
    leftClick: 'LClick',
    rightClick: 'RClick',
    middleClick: 'MClick',
    keyboardEnter: 'KEnter',
    keyboardSpace: 'KSpace'
};
//# sourceMappingURL=Enums.js.map